import { useState } from "react";
import { Nullable } from "primereact/ts-helpers";
import { EducationValue } from "../form.types";

export const useEducationState = (initialEducation: EducationValue[] = []) => {
  const [education, setEducation] =
    useState<EducationValue[]>(initialEducation);

  const addEducation = () => {
    setEducation([
      ...education,
      {
        finished: false,
        finished_at: null,
        institution: null,
        journey_type_id: "",
        started_at: null,
        campus_activities: [],
        fields: [],
        note: "",
        rating: null,
        rating_note: "",
        education_tags: [],
        path_reason: null,
        learner_tag: null,
        degree: null,
      },
    ]);
  };

  const deleteEducation = (index: number) => {
    setEducation(education.filter((_, i) => i !== index));
  };

  const updateEducation = (index: number, updates: Partial<EducationValue>) => {
    setEducation(
      education.map((item, i) =>
        i === index ? { ...item, ...updates } : item,
      ),
    );
  };

  const handlers = {
    onEducationFinishedChange: (index: number, finished: boolean) => {
      updateEducation(index, { finished });
    },

    onEducationStartedAtChange: (index: number, startedAt: Nullable<Date>) => {
      updateEducation(index, { started_at: startedAt });
    },

    onEducationFinishedAtChange: (
      index: number,
      finishedAt: Nullable<Date>,
    ) => {
      updateEducation(index, { finished_at: finishedAt });
    },

    onEducationInstitutionChange: (
      index: number,
      institution: { id: string | null; name: string },
    ) => {
      const normalized = institution
        ? { id: institution.id ?? "", name: institution.name, deleted: false }
        : null;
      updateEducation(index, { institution: normalized as any });
    },

    onEducationJourneyTypeIdChange: (index: number, journeyTypeId: string) => {
      updateEducation(index, { journey_type_id: journeyTypeId });
    },

    onEducationCampusActivitiesChange: (
      index: number,
      campusActivities: string[],
    ) => {
      updateEducation(index, { campus_activities: campusActivities });
    },

    onEducationFieldsChange: (index: number, fields: string[]) => {
      updateEducation(index, { fields });
    },

    onEducationNoteChange: (index: number, note: string) => {
      updateEducation(index, { note });
    },

    onEducationRatingChange: (index: number, rating: number | null) => {
      updateEducation(index, { rating });
    },

    onEducationRatingNoteChange: (index: number, rating_note: string) => {
      updateEducation(index, { rating_note });
    },

    onEducationPathReasonChanged: (index: number, value: string) => {
      updateEducation(index, { path_reason: value });
    },

    onEducationDegreeChanged: (index: number, value: string) => {
      updateEducation(index, { degree: value });
    },

    onEducationLearnerTagChanged: (index: number, value: string) => {
      updateEducation(index, { learner_tag: value });
    },
  };

  return {
    education,
    setEducation,
    addEducation,
    deleteEducation,
    handlers,
  };
};
